import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import css from './MaterialSelect.module.css';
import Select, { components, GroupBase, Props as SelectProps, StylesConfig } from 'react-select';
import classNames from 'classnames';
import { SelectComponentsConfig } from 'react-select/dist/declarations/src/components';

export type SelectOptionBase = {
  value: any;
  label: string;
};

export type StyleConfig = {
  inputTextColor: string;
  inputBorderRadius: string;
  inputBorderHover: string;
  inputBorder: string;
  menuBorder: string;
  menuBorderRadius: string;
};

export type MaterialSelectProps<T> = SelectProps<T> & {
  noBorder?: boolean;
  hint?: string;
  getHint?: (value: any) => string;
  label?: string;
  isRequired?: boolean;
  styleConfig: StyleConfig;
};

const getStyles = (config: StyleConfig): StylesConfig<any, any, any> => ({
  singleValue: (provided, state) => ({
    ...provided,
    color: config.inputTextColor,
  }),
  control: (provided, state) => ({
    ...provided,
    height: '100%',
    paddingLeft: 6,
    borderRadius: config.inputBorderRadius,
    outline: state.isFocused ? config.inputBorderHover : config.inputBorder,
    border: 'solid 0px transparent',
    boxShadow: 'none',
    //outlineWidth: 0,
  }),
  menu: (provided, state) => ({
    ...provided,
    border: config.menuBorder,
    borderRadius: config.menuBorderRadius,
    overflow: 'hidden',
  }),
});

const Control = ({ children, ...props }: any) => {
  const { hasValue, selectProps, isFocused } = props;
  const { placeholder, label, isRequired } = selectProps;
  const hasPlaceholder = !!placeholder;
  return (
    <components.Control {...props}>
      {children}
      {!!label && (
        <div className={classNames(css.label, (hasValue || hasPlaceholder || isFocused) && css.collapse)}>
          {label}
          {isRequired ? ' *' : ''}
        </div>
      )}
    </components.Control>
  );
};
const Components: SelectComponentsConfig<any, any, any> = {
  Control,
};

const MaterialSelect = <T extends SelectOptionBase = SelectOptionBase>(props: MaterialSelectProps<T>) => {
  const { className, noBorder = false, styles, hint, getHint, ...rest } = props;
  const Styles = useMemo(() => {
    return getStyles(props.styleConfig);
  }, [props.styleConfig]);
  return (
    <div className={css.box}>
      <div className={classNames(css.container, className)}>
        <Select<T, boolean>
          {...rest}
          menuPlacement={rest.menuPlacement || 'auto'}
          className={classNames(css.select)}
          styles={Styles}
          components={Components}
        />
      </div>
      {!!hint && <div className={css.hint}>{hint}</div>}
      {!!getHint && <div className={css.hint}>{getHint(rest.value)}</div>}
    </div>
  );
};

export default React.memo(MaterialSelect);

// export * from '@squareping/web.ui.material-select';
// export { default } from '@squareping/web.ui.material-select';

// export * from '../../bit/web/ui/material-select';
// export { default } from '../../bit/web/ui/material-select';
